import { useSubmit } from "@certn/api";
import {
  ButtonGroup,
  PrimaryButton,
  showToast,
  useAddressSchema,
} from "@certn/cascadia";
import { AddressFormFormikField, Grid } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Form, Formik } from "formik";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { object } from "yup";

import { OrderContext } from "../../../pages/order/OrderContext";
import { useOrderBillingProfile } from "../../../pages/order/steps/useOrderBillingProfile";
interface Props {
  onSave: () => void;
}

export function BillingAddressForm(props: Props) {
  const { onSave } = props;
  const { order } = useContext(OrderContext);
  const { t } = useTranslation();
  const schema = object({
    address: useAddressSchema({
      streetAddressFieldName: "address_line_1",
    }),
  });

  const { data, mutate } = useOrderBillingProfile();

  const { submit } = useSubmit(
    `/api/internal/client-portal/order/${order.group}/update-address/`,
    {
      onSuccess: async () => {
        await mutate();
        showToast(t("Billing address updated"), { type: "success" });
        onSave();
      },
    }
  );
  return (
    <Formik
      initialValues={{ address: data?.address }}
      onSubmit={async (values) => {
        await submit(values);
      }}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form className={styles.form}>
            <Grid form rowGap="space-4">
              <AddressFormFormikField testID="billing_address" name="address" />
              <ButtonGroup>
                <PrimaryButton
                  type="submit"
                  size="medium"
                  testID="save_billing_address"
                  isLoading={isSubmitting}
                >
                  {t("Save billing address")}
                </PrimaryButton>
              </ButtonGroup>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
}

const styles = {
  form: css({
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
    paddingTop: "var(--space-2)",
    paddingBottom: "var(--space-2)",
  }),
};
